<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">템플릿 그룹</div>
      </div>
      <div class="vertical-center-box" align="right">
        <el-button size="small" @click="onClickResetButton">해제</el-button>
      </div>
    </el-row>
    <ul class="trigger-list-wrapper">
      <li class="trigger-count-item" v-for="item in triggerList" :key="item.triggerId" @click="onClickProgresssbar(item)" style="cursor:pointer">
        <el-row type="flex" justify="space-between" style="margin-bottom: 2px;">
          <div class="label"><i v-show="item.selected" class="fas fa-check mr-r4"></i>{{item.label}}</div>
          <span class="count">{{item.count}}</span>
        </el-row>
        <el-progress class="c-pointer" :stroke-width="8" :show-text="true" :percentage="item.percentage" :color="item.color"/>
      </li>
    </ul>
  </div>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { chartColorSet } from '@/constants/chart-options';
import AmsExecutionAPI from '@/api/ams/execution';

export default {
  name: 'WGrpList',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    grpFilters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      triggerList: [],
    };
  },
  watch: {
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      if (!this.active) {
        return;
      }
      AmsExecutionAPI.getTriggerCountListByGrpId({}).then((response) => {
        const result = response.data;
        if (result.success) {
          this.setData(result);
        }
      });
    },
    setData(result) {
      const data = cloneDeep(result.data);

      data.forEach((item, index) => {
        item.color = chartColorSet[index];
        item.selected = this.grpFilters.indexOf(item.grpId) > -1;
      });

      this.triggerList = cloneDeep(data);
    },
    onClickProgresssbar(item) {
      if (isNil(item.selected) || !item.selected) {
        item.selected = true;
      } else {
        item.selected = false;
      }
      item.name = item.label;
      this.$emit('set-grp-filter', item);
    },
    deleteResultFilter(filter) {
      if (!isNil(filter)) {
        this.triggerList.filter((item) => item.triggerId === filter.triggerId)[0].selected = false;
      } else {
        this.triggerList.forEach((item) => {
          item.selected = false;
        });
      }
    },
    onClickResetButton() {
      this.deleteResultFilter();
      this.$emit('set-grp-filter');
    },
  },
};
</script>

<style lang="scss">
.trigger-list-wrapper {
  // padding: 5px 10px 0 0;

  .trigger-count-item {
    .label {
      font-size: 12px;
      color: #333; //$deepgray
      font-weight: 500;
    }

    .count {
      font-size: 12px;
      color: #333; //$deepgray
      font-weight: 500;
    }

    & + .trigger-count-item {
      margin-top: 5px;
    }

    .el-progress-bar__outer {
      background: #f3f3f4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecuteTrigger/components/GrpList.vue